import React from "react";

export class Tools{
    public static GenerateRandomLettersColorsJSX(text: string): React.ReactNode {
        const splitted = text.split('');
        const blackIndexes = new Set<number>();
        while (blackIndexes.size < 4) {
            blackIndexes.add(Math.floor(Math.random() * splitted.length));
        }

        let mainIndex: number;
        const mainIndexes= new Set<number>();
        while(mainIndexes.size < 4) {
            mainIndex = Math.floor(Math.random() * splitted.length);

            if(!blackIndexes.has(mainIndex)){
                mainIndexes.add(mainIndex);
            }
        }

        return splitted.map((letter, index) => {
            if (blackIndexes.has(index)) {
                return (
                    <strong key={index} className="first-letter-black">
                        {letter}
                    </strong>
                );
            } else if (mainIndexes.has(index)) {
                return (
                    <strong key={index} className="first-letter-main">
                        {letter}
                    </strong>
                );
            } else {
                return (
                    <strong key={index} className="main-color">
                        {letter}
                    </strong>
                );
            }
        });
    }

}